<template>
  <div class="d-flex">
    <GwBtns
      :options="shadows"
      :value="value"
      idKey="id"
      class="gwbtns_horizontal_grey"
      style="
        background: var(--clr-black-1-3);
        border-radius: 4px;
        --gwbtn-size: 1rem;
        --gwbtn-height: 1.875rem;
        --gwbtns-wrap: wrap;
        --gwbtns-padding: 2px;
      "
      @click="
        (_e, item) => {
          value = item
        }
      "
    >
      <template #default="{ item }">
        {{ $t(`settings.text_${item}`) }}
      </template>
    </GwBtns>
  </div>
</template>

<script>
import GwBtns from '@/components/lib/GwBtns'

export default {
  name: 'SettingsTextOutline',
  components: {
    GwBtns,
  },
  props: {
    propKey: { default: 'textShadowStyle' },
    hasTitle: { type: Boolean, default: true },
  },
  data() {
    this.shadows = [
      'shadow_none',
      'shadow_drop',
      'shadow_higher',
      // 'shadow_lower',
      'shadow_outlined',
    ]
    return {}
  },
  computed: {
    mergedUserSettings() {
      const { mergedUserSettings } = this.$store.getters
      return mergedUserSettings
    },
    value: {
      get() {
        const res = this.mergedUserSettings[this.propKey] || 'shadow_drop'
        return res
      },
      set(value) {
        this.$store.dispatch('userSettings', { [this.propKey]: value })
        this.$store.dispatch('resetColorSettings')
      },
    },
  },
}
</script>
